import React, { useState, useEffect } from 'react'
import { Alert } from 'antd'
import { WifiOutlined } from '@ant-design/icons'

const OfflineIndicator = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [showReconnected, setShowReconnected] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      setShowReconnected(true)
      // Hide reconnected message after 3 seconds
      setTimeout(() => setShowReconnected(false), 3000)
    }

    const handleOffline = () => {
      setIsOnline(false)
      setShowReconnected(false)
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  if (isOnline && !showReconnected) return null

  return (
    <>
      {!isOnline && (
        <Alert
          message="You are currently offline"
          description="Some features may not be available until you reconnect to the internet."
          type="warning"
          banner
          showIcon
          icon={<WifiOutlined />}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            borderRadius: 0,
          }}
        />
      )}
      {showReconnected && (
        <Alert
          message="Connection restored"
          description="You're back online! All features are now available."
          type="success"
          banner
          showIcon
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
            borderRadius: 0,
          }}
        />
      )}
    </>
  )
}

export default OfflineIndicator
